import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { InterviewDataService } from '../student/interview/services/interview-data.service';
import { SharedReviewerService } from '../shared-reviewer.service';
import { HtmlFormatterService } from '../common/utils/html-formatter.service';
import { Subject, BehaviorSubject } from 'rxjs';

declare var window:any;

@Component({
    selector: 'mgr-reviewer',
    templateUrl: './mgr-reviewer.component.html',
    standalone: false
})
export class ManagerReviewerComponent {

    form: UntypedFormGroup;
    editFeedback: any = true;
    current: any;
    question: any;
    currentFeedback: any;
    currentIndex: number = 0;
    attempts: any;
    questions: any;
    requested: any;
    interview: any;
    currentReviewer: any;
    otherFeedback: any;
    interviewId: any = sessionStorage.getItem('interview_id');
    attemptId: any = sessionStorage.getItem('attempt_id');
    idSubscription: any;
    rating: any;
    review: any;
    private modal: any;

    // eventually move to shared service when time permits;
    private _feedback: Subject<object> = new Subject();
    private _currentAttemptId: BehaviorSubject<[]> = new BehaviorSubject(this.attemptId);

    @ViewChild('response', {static: false}) responseComponent: any;

    constructor(
        private fb: UntypedFormBuilder,
        private _dataService: InterviewDataService,
        private _htmlFormatter: HtmlFormatterService,
        private _activatedRoute: ActivatedRoute,
        private _reviewerService: SharedReviewerService
    ) {}

    get currentAttemptId() {
        return this._currentAttemptId.asObservable();
    }

    ngOnInit() {
        this.currentReviewer = window.parent.LOGGED_IN;
        this._dataService.practice = this._activatedRoute.snapshot.queryParamMap.get('practice') || false;
        this.form = this.fb.group({
            review: [''],
            ratings: [this.rating]
        });
        this._reviewerService.feedback.subscribe((fb) => {
            if (fb) {
                this.loadFeedback(fb);
                this.continueToNextQuestion(fb);
            }
        });

        this.idSubscription = this.currentAttemptId.subscribe((attId) => {
            this.attemptId = attId;
        });

        this.loadAttempt();
    }
    loadFeedback(feedback) {
        this.currentFeedback = feedback[0] || null;

        if (this.currentFeedback) {
            this.rating = this.currentFeedback.rating;
            this.review = this.currentFeedback.review;
        } else {
            this.rating = '';
            this.review = '';
        }

        this.form.controls['ratings'].setValue(this.rating);
        this.form.controls['review'].setValue(this.review);
        if (this.rating !== '' || this.form.controls['review'].value) {
            this.editFeedback = false;
        } else {
            this.editFeedback = true;
        }
        this.otherFeedback = this.question['feedback'].filter(feedback => feedback.reviewer !== this.currentReviewer) || [];
    }

    continueToNextQuestion(fb) {
        if (this.question === this.current.questions[this.current.questions.length - 1]) {
            let modal = this._reviewerService.openReviewerModal('send-feedback', this.current, this.currentReviewer);
            modal.result.then((res) => {
                if (res) {
                    this._reviewerService.sendFeedbackNotification(this.attemptId);
                } else {
                    this.editFeedback = true;
                }
            })
        }
        this.playCurrentAttempt();
        this.responseComponent.nextQuestion();
    }

    loadAttempt() {
        this._dataService.getInterview(this.interviewId);
        this._dataService.interview.subscribe((resp: any) => {
            if (resp) {
                this.attempts = resp.attempts;
                this.attempts.forEach(att => {
                    att.created = this._htmlFormatter.formatTzDate(att.created);
                })
                this.playCurrentAttempt();
            }
        });
    }

    playCurrentAttempt(id: any = this.attemptId) {
        // keeps track of attempt id when it changes since the initial id comes from the window
        this._currentAttemptId.next(id);
        this._dataService.getAttempt(id);
        this._dataService.attempt
            .subscribe((resp: any) => {
                if (resp) {
                    this.current = resp[0];
                }
            });
    }

    isRequested() {
        this.requested = true;
    }

    currentQuestion(question) {
        this.question = question;
        let feedback = [];
        if (this.question.feedback.length) {
            feedback = this.question.feedback.filter((f) => {
                return f.reviewer === this.currentReviewer
            });
            if (this.rating || this.form.controls['review'].value) {
                this.editFeedback = false;
            }
        }
        this.loadFeedback(feedback);
    }

    onClick(rating: any): void {
        this.form.controls['ratings'].setValue(rating.toString());
    }

    clearRating() {
        this.form.controls['ratings'].setValue('');
    }

    addFeedback() {
        let data = Object.create(null);
        data.review = this.form.value.review;
        data.rating = this.form.value.ratings;
        data.video_interview_question_wrapper_id = this.question.question_wrapper_id;
        if (this.currentFeedback) {
            if (this.currentFeedback['video_interview_feedback_id']) {
                data.video_interview_feedback_id = this.currentFeedback['video_interview_feedback_id'];
            }
        }
        this._reviewerService.saveFeedback(this._dataService.attemptId, data);
    }

    editCurrentFeedback() {
        this.editFeedback = true;
        this.form.controls['review'].setValue(this.currentFeedback.review);
        this.form.controls['ratings'].setValue(this.currentFeedback.rating);
    }

    cancelReview(): void {
        if (window.parent && window.parent !== window) {
            window.parent.location.href = window.parent.location.pathname + '?mode=list&subtab=pendingAttempts';
        }
    }

}

